import moment from 'moment';

export const getDefaultYearFilter = (): { year: string } => {
  return {
    year: String(moment().year()),
  };
};
